import { Dropdown, DropdownProps } from 'components/dropdown/Dropdown';
import { DropdownInlineEditorProps } from 'components/inline_edit/DropdownInlineEditor';
import { dropdownTriggerStyles } from 'pages/Desk/issues/issue_modals/shared';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export type ProfileDropdownOption<TValue extends string> = {
    Value: TValue;
    Text: string;
};

export type ProfileSettingDropdownInlineEditorProps<TValue extends string> = Omit<
    DropdownInlineEditorProps<ProfileDropdownOption<TValue>>,
    'dropdownConfig' | 'renderValue'
>;

// wrapped to pass down classname for styled components to trigger, since thats
// what we want to style here
function WrappedDropdown<T>({
    className,
    ...props
}: DropdownProps<T> & { className?: string }) {
    return (
        <Dropdown<T>
            {...props}
            trigger={{
                ...props.trigger,
                className: `${className} ${props.trigger?.className ?? ''}`,
            }}
        />
    );
}

const StyledDropdown = styled(WrappedDropdown)`
    border: 1px solid var(--border-default);
    transition: background-color 0.075s;
    &:hover {
        background-color: var(--action-hover) !important;
    }
    &:active {
        background-color: var(--action-selected) !important;
    }
` as typeof WrappedDropdown;

export function ProfileSettingDropdown<TValue extends string>(
    props: ProfileSettingDropdownInlineEditorProps<TValue>
) {
    return (
        <StyledDropdown<ProfileDropdownOption<TValue>>
            {...props}
            renderLabel={({ value }) => value?.Text}
            renderItem={({ item }) => item.Text}
            dataKey={(item) => item.Value}
            data={props.options}
            value={props.value}
            onChange={props.onConfirm}
            isDisabled={props.isDisabled}
            popup={{ width: 'max-content' }}
            trigger={{
                style: {
                    ...dropdownTriggerStyles,
                    backgroundColor: tokens.input.background,
                    margin: 0,
                },
            }}
        />
    );
}
